(function () {
  'use strict';

  angular.module('ringbaPortal').component('insightsVueContainer', {
    bindings: {
      columnState: '<'
    },
    controller: InsightsVueController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/reporting-v2/insights-vue-container.view.html'
  });

  function InsightsVueController(
    $state,
    $stateParams
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;

    function onInit() {
      vm.insightId = $stateParams.insightId ? $stateParams.insightId : null;
      vm.selectedGroupBys = $state.current.data.selectedGroupBys ? $state.current.data.selectedGroupBys : undefined;
      vm.initialExpandAllGroups = !!$state.current.data.initialExpandAllGroups;
      vm.sortOrder = $state.current.data.sortOrder;
      vm.quickDateRangeSelector = $state.current.data.quickDateRangeSelector;
      vm.title = $state.current.data.title;
    }

  }
})();
